import {
  Avatar,
  Box,
  Button,
  Grid,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import React from "react";
import { useUser } from "../contexts/useUser";
import { useQuery } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { fetchLLMPrompts } from "../dataaccess/fetchLLMPrompts";

const Prompts: React.FC = () => {
  const { project } = useUser();
  const navigate = useNavigate();

  const [keyFilter, setKeyFilter] = React.useState<string | undefined>(
    undefined
  );

  const { data, isLoading, isError } = useQuery({
    queryKey: ["prompts"],
    queryFn: () => fetchLLMPrompts(project?.id ?? ""),

    enabled: project?.id && project?.id.length > 0 ? true : false,
  });

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (isError) {
    return <div>Error...</div>;
  }

  const prompts = data?.data?.promptsByProjectIdAndKey?.items ?? [];

  return (
    <>
      <Box p={2}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Paper elevation={3} style={{ borderRadius: 2, height: 100 }}>
              <Box
                display="flex"
                justifyContent="flex-start"
                alignItems="center"
                height="100%"
              >
                <TextField
                  label="Filter by key"
                  variant="outlined"
                  onChange={(e) => setKeyFilter(e.currentTarget.value)}
                  value={keyFilter}
                  size="small"
                  sx={{ marginLeft: 2, width: 300 }}
                />

                <Button
                  variant="text"
                  sx={{ marginLeft: 2 }}
                  onClick={() => {
                    setKeyFilter("");
                  }}
                >
                  reset
                </Button>
              </Box>
            </Paper>
          </Grid>

          <Grid item xs={12}>
            <Paper elevation={3} style={{ borderRadius: 2 }}>
              <Box height="100%">
                <List>
                  {prompts
                    .filter((prompt) => {
                      if (
                        keyFilter &&
                        prompt?.key
                          ?.toLowerCase()
                          .indexOf(keyFilter.toLowerCase()) === -1
                      ) {
                        return false;
                      }

                      return true;
                    })
                    .map((prompt) => (
                      <ListItem
                        key={prompt?.id}
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          cursor: "pointer",
                        }}
                        onClick={() => navigate(`edit/${prompt?.id}`)}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            flexGrow: 1,
                          }}
                        >
                          <Button
                            variant="contained"
                            onClick={(event) => {
                              event.stopPropagation();
                              navigator.clipboard
                                .writeText(prompt?.key ?? "")
                                .then(() => {});
                            }}
                          >
                            Copy key
                          </Button>
                          <ListItemText
                            primary={`${prompt?.name} - ${prompt?.key}`}
                            secondary={`status: ${prompt?.status} ${
                              prompt?.description !== ""
                                ? " - " + prompt?.description
                                : ""
                            } Last updated: ${new Date(
                              prompt?.updatedAt ?? ""
                            ).toLocaleString()}`}
                            sx={{ marginLeft: 2 }}
                          />
                        </Box>

                        <Box
                          sx={{ display: "flex", justifyContent: "flex-end" }}
                        >
                          <Button
                            variant="text"
                            onClick={(event) => {
                              event.stopPropagation();
                              navigate(`edit/${prompt?.id}`);
                            }}
                          >
                            Edit
                          </Button>
                        </Box>
                      </ListItem>
                    ))}
                </List>
                <Button onClick={() => navigate("new")}>New Prompt</Button>
              </Box>
            </Paper>
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

export default Prompts;
